import { NopCollector_instance2794m19vxdmgu as NopCollector_instance } from './internal/NopCollector.mjs';
import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *collect(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.t1d(NopCollector_instance, $completion);
}
function *emitAll(_this__u8e3s4, flow, $completion) {
  ensureActive(_this__u8e3s4);
  yield* flow.t1d(_this__u8e3s4, $completion);
  return Unit_instance;
}
//region block: exports
export {
  collect as collectqvo4h3wr0nez,
  emitAll as emitAll157ci673e68ia,
};
//endregion

//# sourceMappingURL=Collect.mjs.map
